<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-14 11:47:16
 * @LastEditors: hayuu
 * @LastEditTime: 2024-09-14 14:30:13
-->
<template>
    <div class="alert_box">
        <div class="dia_box">
            <div class="dia_header">
                <h3>{{ title }}</h3>
                <img src="@/assets/images/tc_close_btn.png" alt="" @click="handleCancel">
            </div>
            <div class="dia_body">
                <img :src="imgUrl" alt="" v-if="imgUrl">
                <p>{{ content }}</p>
                <div class="btns">
                    <div class="btn" @click="handleCancel" v-if="showCancelButton">{{ cancelButtonText }}</div>
                    <div class="btn primary" @click="handleConfirm" element-loading-spinner="el-icon-loading"
                        v-loading="cancelButtonLoading">{{ confirmButtonText }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => {
                return "";
            },
        },
        content: {
            type: String,
            default: () => {
                return "";
            },
        },
        imgUrl: {
            type: String,
            default: () => {
                return "";
            },
        },
        confirmButtonText: {
            type: String,
            default: () => {
                return "确认";
            },
        },
        cancelButtonText: {
            type: String,
            default: () => {
                return "关闭";
            },
        },
        showCancelButton: {
            type: Boolean,
            default: () => {
                return true;
            }
        }
    },
    data() {
        return {
            cancelButtonLoading: false
        }
    },
    methods: {
        handleCancel() {
            this.ding()
            this.$emit("cancel")
        },
        handleConfirm() {
            this.ding()
            this.$emit("confirm")
        },
    }
}
</script>

<style lang="less" scoped>
.alert_box {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);

    .dia_box {
        position: absolute;
        top: 210px;
        left: calc(50% - 429px);
        width: 858px;

        .dia_header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 93px;
            padding: 8px 30px 25px;
            background-image: url(@/assets/images/xx_title_bg.png);
            background-size: 100% 100%;

            h3 {
                font-weight: 600;
                font-size: 28px;
                color: #FFFFFF;
                line-height: 60px;
                text-align: left;
            }

            img {
                width: 23px;
                height: 23px;
            }
        }

        .dia_body {
            width: 100%;
            height: 566px;
            margin-top: -19px;
            padding-top: 47px;
            background: #FFFFFF;
            box-shadow: 0px 4px 4px 0px rgba(212, 212, 212, 0.25);
            border-radius: 16px 16px 16px 16px;

            img {
                width: 300px;
                height: 224px;
                margin-bottom: 31px;
            }

            p {
                width: 600px;
                margin: 0 auto;
                margin-bottom: 56px;
                font-size: 26px;
                color: #000000;
                line-height: 30px;
            }

            .btns {
                display: flex;
                justify-content: center;

                .btn {
                    width: 300px;
                    height: 66px;
                    margin-right: 30px;
                    background: #B2C4E2 #3F87FF #FFFFFF;
                    box-shadow: 0px 6px 0px 0px #BFD7FF;
                    border-radius: 16px 16px 16px 16px;
                    border: 1px solid #3F87FF;
                    font-weight: 600;
                    font-size: 26px;
                    color: #3F87FF;
                    line-height: 66px;
                    text-align: center;
                }

                .primary {
                    margin-right: 0;
                    background: #3F87FF;
                    box-shadow: 0px 6px 0px 0px #0047BE;
                    color: #FFFFFF;
                }
            }
        }
    }

}
</style>